import gsap from 'gsap';
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { SplitText } from "gsap/SplitText";
import Flickity from 'flickity-fade';
import LazyLoad from 'vanilla-lazyload'
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Splitting from 'splitting'
import inView from 'in-view'

gsap.registerPlugin(MorphSVGPlugin, SplitText, Draggable, InertiaPlugin, ScrollTrigger);

const HTML = document.querySelector('html');

class App {
  constructor() {

    // Lazyload
    this.lazyload = new LazyLoad({ 
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: 600,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        }
      },
      callback_loaded : (el) => {
        const figure = el.closest('figure');
        if( figure ) figure.classList.add('img-is-loaded')
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Submenu hover
    const nav = document.querySelector('.main-nav');
    const links = nav.querySelectorAll('.has-children, .menu-item-has-children');
    if( links ) {
      links.forEach(link => {
        const submenu = link.querySelector('.submenu');
        if( window.innerWidth < 1024 ) {
          link.children[0].addEventListener('click', (e) => {
            e.preventDefault();
            submenu.classList.remove('hidden')
            gsap.to(nav, { duration : 0.4, x : '-100%', ease : 'power1.inOut' });
          })

          // Btn back
          if( submenu ) {
            const back = submenu.querySelector('.back');
            if( back ) {
              back.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                gsap.to(nav, { duration : 0.4, x : '0%', ease : 'power1.inOut', onComplete : () => {
                  submenu.classList.add('hidden')
                } });
              })
            }
          }
        } else {
          link.addEventListener('mouseenter', () => {
            gsap.to(submenu, { duration : 0.4, height : submenu.children[1].offsetHeight, delay: 0.15, ease : 'power1.inOut' });
          })
          link.addEventListener('mouseleave', () => {
            gsap.to(submenu, { duration : 0.4, height : 0, delay : 0.15, ease : 'power1.inOut' });
          })
        }
      })
    }

    // Toggle menu
    const toggle = document.querySelector('.toggle-menu');
    if( toggle ) {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        
        if( HTML.classList.contains('open-sidebar') ) {
          HTML.dispatchEvent(new Event('click'))
        }

        if( HTML.classList.contains('open-menu') ){
          closeMenu();
        }
        else 
          HTML.classList.add('open-menu');
      })

      HTML.addEventListener('click', e => {
        if( !e.target.classList.contains('main-nav') && !e.target.closest('.main-nav') && HTML.classList.contains('open-menu') ) {
          e.stopPropagation();
          closeMenu();
        }
      })
      
      function closeMenu() {
        let pos = nav.getBoundingClientRect();
        let delay = 0;
        if( pos.x < 0 ) {
          delay = 400;
          const backs = document.querySelectorAll('.submenu .back');
          if( backs ) {
            backs.forEach(el => el.dispatchEvent(new Event('click')));
          }
        }
        setTimeout(() => {
          HTML.classList.remove('open-menu');
        }, delay)
      }
    }

    // Morph button svg
    const buttons = document.querySelectorAll('.btn');
    if( buttons ) {
      buttons.forEach(btn => {
        const shapes = btn.querySelectorAll('path');
        if( shapes ) {

          shapes.forEach(shape => {
            shape.dataset.initial = shape.getAttribute('d');
          })

          btn.addEventListener('mouseenter', e => {
            shapes.forEach(shape => {
              if( shape.dataset.hover ) {
                gsap.to(shape, { duration : .5, rotation : 90, transformOrigin: '50% 50%', morphSVG : shape.dataset.hover, ease : 'circ.inOut' })
              }
            })
          })
          btn.addEventListener('mouseleave', e => {
            shapes.forEach(shape => {
              gsap.to(shape, { duration : .5, rotation : 0, morphSVG : shape.dataset.initial, ease : 'circ.inOut' })
            })
          })
        }
      })
    }

    // Split title by line
		// let results = Splitting({
		// 	target : '.wysiwyg h2', 
		// 	by : 'lines'
		// });

		// let whitespace = document.createElement('span');
		// whitespace.classList.add('whitespace')
		// whitespace.innerHTML = ' ';

		// results.forEach((r) => {
		// 	r.el.innerHTML = '';
		// 	r.lines.forEach((line) => {

		// 		let span = document.createElement('span');
		// 		span.classList.add('line')
		// 		r.el.appendChild(span)

    //     let txtLine = '';
		// 		line.forEach((word, i) => {
    //       txtLine += word.innerText

		// 			if( i < line.length - 1)
    //         txtLine += " "
		// 		})
    //     span.innerHTML = txtLine;
    //     span.setAttribute('data-line', txtLine)
		// 	})
		// 	r.el.classList.add('ready')
		// })

    const eventsLayer = document.querySelectorAll('.events-layer ');
    if( eventsLayer ) {
      eventsLayer.forEach(el => {
        const items = el.querySelectorAll('.events-layer__item')
        const imgs = el.querySelectorAll('.events-layer__img')
        gsap.set(imgs[0], { clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0% 100%)" })
        if( items ) {
          items.forEach((item, i) => {

            if( i == 0 ) return;

            gsap.to(imgs[i], {
              scrollTrigger: {
                trigger: item,
                scrub: true,
                start: "top bottom",
                end: "+=50%",
                onEnter: function({progress, direction, isActive}) {
                  gsap.set(imgs[Array.from(items).indexOf(item)], { zIndex : 2 });
                } 
              },
              clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0% 100%)",
              ease: "none"
            });
          })
        }
      
      })
    }

    /** COMPONENTS */
    this.cover();
    this.sticky();
    this.sidebar();
    this.carousel();
    this.accordion();
    this.slider();
    this.gallery();
    this.frise();
    /**  */

    // In viewport
	  inView.offset(window.innerHeight * .2);
		inView('.js-reveal:not(.is-visible)')
    	.on('enter', function(elt) {
        if( elt.classList.contains('is-visible')) elt.dispatchEvent(new Event('inview'))
        elt.classList.add('is-visible');
      })
      .on('exit', function(elt) {
      })
  }

  sidebar() {
    const triggers = document.querySelectorAll('[data-sidebar]');
    let current = null;
    if( triggers ) {
      triggers.forEach(trigger => {
        const target = document.querySelector(trigger.dataset.sidebar);

        if( target ) {
          // Close btn
          const close = target.querySelector('.trigger-close')
          if( close ) {
            close.addEventListener('click', e => {
              e.preventDefault();
              HTML.dispatchEvent(new Event('click'))
              return;
            })
          }
        }

        trigger.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          let delay = 0;

          if( trigger.classList.contains('active')) {
            HTML.dispatchEvent(new Event('click'))
            return;
          }

          if( HTML.classList.contains('open-menu') ) HTML.dispatchEvent(new Event('click'))

          if( current !== null ) {
            current.trigger.classList.remove('active');
            current.sidebar.classList.remove('show')
            delay = 300;
          }

          if( target ) {

            setTimeout(() => {
              target.classList.add('show')
            }, delay)

            trigger.classList.add('active');
            HTML.classList.add('open-sidebar');

            current = {
              'sidebar' : target,
              'trigger' : trigger
            }
          }
        })
      })

      HTML.addEventListener('click', e => {
        if( current != null &&
            e.target != current.trigger && 
            e.target != current.sidebar && 
            e.target.closest('.sidebar') != current.sidebar ) {
          current.trigger.classList.remove('active');
          current.sidebar.classList.remove('show')
          HTML.classList.remove('open-sidebar');

          current = null;
        }
      })
    }
  }

  cover() {
    const sliders = document.querySelectorAll('.cover--slider');
    if( sliders) {
      sliders.forEach(slider => {
        const $imgs = slider.querySelectorAll('figure img')
        let current = -1;
        const flkty = new Flickity(slider, {
          fade : true,
          draggable: false,
          prevNextButtons: false,
          duration: 8000,
          autoPlay: 5000,
          pauseAutoPlayOnHover: false,
          on : {
            select : function(index) {
              if( current != index) {
                if( current >= 0 ){
                  // Move text
                  const prev = this.cells[this.prevSelectedIndex].element
                  const prevW = prev.querySelector('.wysiwyg')
                  const prevContent = prevW.children;
                  gsap.to(
                    prevContent, 
                    { 
                      y : '3rem', 
                      autoAlpha : 0, 
                      stagger: 0.1, 
                      delay: 0.6 
                    }
                  )
                  
                }

                // Move text
                const elt = this.cells[index].element
                const wysiwyg = elt.querySelector('.wysiwyg')
                const content = wysiwyg.children;
                gsap.fromTo(
                  content, 
                  { 
                    y : '3rem', 
                    autoAlpha : 0 
                  }, 
                  { 
                    y : '0rem', 
                    autoAlpha : 1, 
                    stagger: 0.1, 
                    ease : 'expo.out', 
                    duration : 1.2, 
                    delay: 0.6 
                  }
                )
              }

              current = index;
            },
          }
        })
      })
    }
  }


  sticky() {
    const stickys = document.querySelectorAll('.sticky');

    if( window.innerWidth < 1024 ) return;
    
    if( stickys ) {
      stickys.forEach(el => {
        const parent = el.parentElement;

        window.addEventListener('scroll', (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();

          // Now sticky
          if( pPos.top <= 0 ) {
            el.style.width = `${pPos.width}px`

            if( pPos.bottom - pos.height <= 0 ) {
              el.style.position = 'absolute'
              el.style.top = `auto`
              el.style.bottom = `0px`
              el.style.left = `0px`
            } else {
              el.style.position = 'fixed'
              el.style.top = `0px`
              el.style.bottom = `auto`
              el.style.left = `${pPos.x}px`
            }
          } else {
            el.style.position = 'relative'
            el.style.top = `0px`
            el.style.bottom = `auto`
            el.style.left = `0px`
            el.style.width = `100%`
          }
        })
      })
    }
  }

  carousel() {
    const carousels = document.querySelectorAll('.carousel')
    if( carousels ) {
      carousels.forEach(carousel => {
        new Flickity(carousel, {
          lazyLoad: 3,
          prevNextButtons: false,
          wrapAround : true
        })
      })
    }
  }


  gallery() {
    const galleries = document.querySelectorAll('.gallery')
    if( galleries ) {
      galleries.forEach(gallery => {
        // Build scrollbar
        const scrollbar = document.createElement('div')
        scrollbar.classList.add('scrollbar')
        const bar = document.createElement('div')
        bar.classList.add('bar')
        scrollbar.append(bar)
        
        new Flickity(gallery, {
          lazyLoad: 9,
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          cellAlign : 'left',
          on : {
            ready : function() {
              // On ajout la scrollbar
              gallery.append(scrollbar);
            },
            scroll: (progress) => {
              if (bar) {
                bar.style.width = `${(progress < 0 ? 0 : progress) * 100}%`;
              }
            },
          }
        })
      })
    }
  }

  slider() {
    const slider = document.querySelectorAll('.slider');
    if( slider ) {
      slider.forEach(elt => {
        const sliderTxt = elt.querySelector('.slider-txt')
        const sliderImg = elt.querySelector('.slider-img');
        const navs = elt.querySelectorAll('.slider__nav a');
        let flktyImg = null
        let flkty = null

        if( sliderImg ) {
          const imgs = sliderImg.querySelectorAll('img')
          flktyImg = new Flickity(sliderImg, {
            pageDots : false,
            prevNextButtons : false,
            lazyLoad: 3,
            on : {
              change : function(index) {
                if( flkty ) {
                  flkty.select(index)
                }
              },
              scroll : function() {
                this.slides.forEach( ( slide, i ) => {
                  var img = imgs[i];
                  var x = ( slide.target + this.x ) * -1/3;
                  img.style.transform = 'translateX(' + x  + 'px)';
                });
              }
            }
          })
        }
        if( sliderTxt ) {
          let current = -1;
          flkty = new Flickity(sliderTxt, {
            fade : true,
            prevNextButtons : false,
            on : {
              ready : function() {
                elt.append(this.pageDots.holder)
              },
              change : function(index) {
                if( flktyImg ) {
                  flktyImg.select(index)
                }
              },
              select : function(index) {

                if(current != index ) {
                  if( current >= 0 ) {
                    gsap.to(
                      this.cells[current].element.querySelector('.wysiwyg').children, 
                      {
                        duration: 0.3,
                        stagger: 0.1,
                        y: '-3rem',
                        autoAlpha : 0
                      }
                    );
                  }
                  gsap.fromTo(
                    this.cells[index].element.querySelector('.wysiwyg').children, 
                    {
                      y : '3rem',
                      autoAlpha : 0
                    }, 
                    {
                      duration: 1,
                      stagger: 0.1,
                      y: '0rem',
                      autoAlpha : 1,
                      delay: 0.3,
                      ease: 'expo.out'
                    }
                  );
                }

                current = index
              } 
            }
          })

          if( navs ) {
            navs.forEach(nav => {
              nav.addEventListener('click', e => {
                e.preventDefault();
                let index = 0;
                const nbSlides = flkty.cells.length;

                if( nav.classList.contains('prev')) {
                  index = current == 0 ? nbSlides - 1 : current - 1;
                } else {
                  index = current == nbSlides - 1 ? 0 : current + 1;
                }
                flkty.select(index)
              })
            })
          }
        }
      })
    }
  }

  accordion() {
    const accordions = document.querySelectorAll('.accordion');

    if( accordions ) {
      accordions.forEach(accordion => {
        const links = accordion.querySelectorAll('.header');

        if( links ) {
          links.forEach(link => {
            link.addEventListener('click', e => {
              e.preventDefault();

              const parent = link.parentElement;
              const content = link.nextElementSibling;

              parent.classList.toggle('open')

              if( content ) {
                gsap.to(
                  content, 
                  { 
                    duration : 0.5,
                    ease : 'expo.inOut',
                    height : parent.classList.contains('open') ? content.children[0].offsetHeight : 0 
                  }
                )
              }
            })
          })
        }
      })
    }
  }

  frise() {
    const frises = document.querySelectorAll('.frise')
    
    if( frises ) {
      
      frises.forEach(frise => {
        const inner = frise.querySelector('.inner');
        const scrollbar = frise.querySelector('.scrollbar span')

        let draggable =Draggable.get(frise);
        window.addEventListener('resize', () => {

          if( window.innerWidth < 992 && draggable ) {
            draggable.kill()
            gsap.set(inner, { x : 0 });
            draggable = null
          } else if ( draggable == undefined && window.innerWidth >= 992 ) {
            const maxX = inner.offsetWidth - window.innerWidth;

            draggable = new Draggable(inner, {
              bounds : frise,
              dragResistance : 0.6,
              edgeResistance : .8,
              type : 'x',
              inertia: true,
              onThrowUpdate : updateScrollbar,
              onDrag : updateScrollbar
            });

            function updateScrollbar() {
              if( scrollbar ) {
                gsap.set(scrollbar, { width : `${(draggable.x / maxX) * -100}%` })
              }
            }
            
            frise.addEventListener('wheel', e => {
              if (!e.deltaY) {
                return;
              }

              if( draggable ) {
                draggable.x -= e.deltaY;
                
                if( draggable.x > 0 ) draggable.x = 0
                else if ( draggable.x < -maxX ) draggable.x = -maxX;
                
                gsap.set(inner, { x : draggable.x });
                updateScrollbar();
                draggable.update();
                // e.currentTarget.scrollLeft += e.deltaY + e.deltaX;
                e.preventDefault();
              }
            })
          }
        })

        window.dispatchEvent(new Event('resize'))
      })
    }
  }
}

 
window.addEventListener('load', () => {
  new App();
})  